/* Product Vuex State Management
import { stateProduct, gettersProduct, mutationsProduct, actionsProduct} from './product'
*/
import axios from '@axios';

const stateProduct = {
  Products: [],
  ProductsTotal: 0,
  Product: {}
}

const gettersProduct = {
};

const mutationsProduct = {
  PRODUCT_LIST_SET(state, value) {
    state.Products = value.items;
    state.ProductsTotal = value.total;
  },
  PRODUCT_ITEM_SET(state, value) {
    state.Product = value;
  }
};

const actionsProduct = {
    fetchProducts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${ctx.rootState.apiUrl}/api/products`, queryParams)
          .then(response => {
            const { items, total } = response.data;
            ctx.commit('PRODUCT_LIST_SET', {
              items: items,
              total: total
            });
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchProduct(ctx, { id }) {
        return new Promise((resolve, reject) => {
            axios
            .get(`${ctx.rootState.apiUrl}/api/products/${id}`)
            .then(response => {
              ctx.commit('PRODUCT_ITEM_SET', response.data);
              resolve(response)
            })
            .catch(error => reject(error))
        })
    },
    updateProduct(ctx, { id, entity }) {

      ctx.commit('PRODUCT_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .put(`${ctx.rootState.apiUrl}/api/products/${id}`, entity)
        .then(response => {
          ctx.commit('PRODUCT_ITEM_SET', response.data); // allow for server-side data
          ctx.commit('SNACKBAR_ADD', { color: "secondary", message: " Saved." });
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
    createProduct(ctx, { entity }) {

      ctx.commit('PRODUCT_ITEM_SET', entity);  // update immediately
      return new Promise((resolve, reject) => {
        axios
        .post(`${ctx.rootState.apiUrl}/api/products/create`, entity)
        .then(response => {
          ctx.commit('PRODUCT_ITEM_SET', response.data); // allow for server-side data
          resolve(response)
        })
        .catch(error => {
          if (error.response && error.response.data) return reject(error.response.data);
          return reject(error);
        })
      })
    },
    fetchProductsLookup(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        if (queryParams.id) {
          axios
            .get(`${ctx.rootState.apiUrl}/api/products/${queryParams.id}`)
            .then(response => {
              resolve(response.data)
            })
            .catch(error => reject(error));
        } else {
          axios
            .post(`${ctx.rootState.apiUrl}/api/products`, queryParams)
            .then(response => {
              resolve(response.data.items);
            })
            .catch(error => reject(error));
        }
      });
    },
}

export {
  stateProduct,
  gettersProduct,
  mutationsProduct,
  actionsProduct
}